import { ImageProps } from 'components/atoms/Image';
import { HealthGoalTypesType } from 'components/molecules/HealthGoalSelection';
import { CoachExpertDtoType } from 'types/services/magnolia/dtos/CoachExpertDto';
import { ProgramPreviewActionType } from './programPreview.actionCreators';
import {
	FLUSH_PROGRAM_PREVIEW,
	LOAD_FAILURE,
	LOAD_SUCCESS,
	OVERWRITE,
	OVERWRITE_FAILURE,
	OVERWRITE_SUCCESS,
	REPLACE,
	REPLACE_FAILURE,
	REPLACE_SUCCESS,
	RESET_HAS_PROGRAM_CHANGED,
	START,
	START_FAILURE,
	START_SUCCESS,
} from './programPreview.actionTypes';

export type ProgramSlugsType = {
	de?: string;
	fr?: string;
	it?: string;
};

export type ProgramContainsType = {
	calories: number;
	days: number;
	productDynamic: number;
	productEditorial: number;
	recipes: number;
	slogans: number;
	tips: number;
	todos: number;
	trackings: number;
	workouts: number;
};

export type ProgramPreviewType = {
	inactive: boolean;
	intensity: number;
	isNewProgram: boolean;
	previewActive: boolean;
	hideExpertLogo: boolean;
	experts: CoachExpertDtoType[];
	externalId?: string;
	goal?: HealthGoalTypesType;
	previewImage?: ImageProps;
	previewImageMale?: ImageProps;
	previewImageFemale?: ImageProps;
	slug?: string;
	title?: string;
	seoTitle?: string;
	dynamicWorkouts: boolean;
	dynamicRecipes: boolean;
	slugs?: ProgramSlugsType;
	contains?: ProgramContainsType;
	metaDescription?: string;
	tools?: Array<Object>; // TODO: Types
	previewItems?: Array<Object>; // TODO: Types
};

export type ProgramPreviewStateType = {
	error: null | Error;
	loaded: boolean;
	slug?: string;
	isLoadingProgram: boolean;
	startProgramFailed: boolean;
	hasProgramChanged: boolean;
} & ProgramPreviewType;

export type RootStateType = {
	programPreview: ProgramPreviewStateType;
};

// Reducer and initial state
// -----------------------------

export const initialState: ProgramPreviewStateType = {
	error: null,
	loaded: false,
	experts: [],
	hideExpertLogo: false,
	isLoadingProgram: false,
	startProgramFailed: false,
	hasProgramChanged: false,
	inactive: false,
	dynamicRecipes: false,
	dynamicWorkouts: false,
	isNewProgram: false,
	previewActive: false,
	intensity: 0,
};

export default (state: ProgramPreviewStateType = initialState, action: ProgramPreviewActionType) => {
	switch (action.type) {
		case FLUSH_PROGRAM_PREVIEW:
			return { ...initialState };
		case LOAD_SUCCESS:
			return {
				...state,
				...action.programPreviewData,
				loaded: true,
				isLoadingProgram: false,
			};
		case LOAD_FAILURE:
			return {
				...state,
				error: action.error,
			};
		case REPLACE:
		case OVERWRITE:
		case START:
			return {
				...state,
				error: null,
				isLoadingProgram: true,
			};
		case REPLACE_SUCCESS:
		case OVERWRITE_SUCCESS:
		case START_SUCCESS:
			return {
				...state,
				error: null,
				startProgramFailed: false,
				hasProgramChanged: true,
				isLoadingProgram: false,
			};
		case RESET_HAS_PROGRAM_CHANGED:
			return {
				...state,
				hasProgramChanged: false,
			};
		case REPLACE_FAILURE:
		case OVERWRITE_FAILURE:
		case START_FAILURE:
			return {
				...state,
				startProgramFailed: action.response,
				isLoadingProgram: false,
			};
		default:
			return state;
	}
};
